const DrawerHandle = () => <div className="mx-auto mt-4 p-1 w-16 rounded-full bg-black" />;

DrawerHandle.displayName = "DrawerHandle";

export { DrawerHandle };
